module.exports = __webpack_public_path__ + "static/assets/d7c263d4f052618c7b967f61346901d3.png";